import { stepTypeState } from "atoms/controller";
import { StepTypes } from "models/controller";
import { Fragment } from "react";
import { useRecoilValue } from "recoil";
import Answer from "./Answer";
import Intro from "./Intro";
import Problem from "./Problem";
import Result from "./Result";

export interface QuizBodyProps {
  answer?: number;
  handleAnswerChange: (sa: number) => void;
}

const QuizBody: React.FC<QuizBodyProps> = ({ answer, handleAnswerChange }) => {
  const stepType: StepTypes = useRecoilValue(stepTypeState);

  return (
    <Fragment>
      <div className="container mx-auto py-6 px-10 h-full flex flex-row text-center">
        {stepType === StepTypes.INTRO && <Intro />}
        {stepType === StepTypes.PROBLEM && (
          <Problem answer={answer} handleAnswerChange={handleAnswerChange} />
        )}
        {stepType === StepTypes.ANSWER && <Answer />}
        {stepType === StepTypes.RESULT && <Result />}
      </div>
    </Fragment>
  );
};

export default QuizBody;
